import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "./InputWrapper";
import ButtonWrapper from "./ButtonWrapper";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import PapayaLogo from "../assets/PAPAYA_LOGO.svg";
import { Divider, Slider } from "antd";
import CnyWarningModal from "./CnyWarningModal";
import isChinese from "is-chinese";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const CardWrapper = styled.div`
  height: auto;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 100%;
  background: #fff;
  /* padding: 20px 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
  p {
    font-size: 16px;
  }
`;

const CnyMethodTransactionInfoCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [fullRegisterName, setFullRegisterName] = useState("");
  const [errorEmptyField, setErrorEmptyField] = useState("");

  const { data } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  const { modalShow, modalData } = useSelector(
    (state) => state.warningModalReducer
  ); //Warning modal data

  const { isLoading } = useSelector((state) => state.postQrInitManualReducer);

  // -----checking link is verify or not---------
  const { error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  const handleProceedFunc = () => {
    setErrorEmptyField("");
    setFullRegisterName("");

    let qrManualTransactionParams = {
      transactionId: data.trxRef,
      type: "cny-ob",
      amount: parseFloat(data?.amount),
      sessionId: data.sessionToken,
      userId: data.merchantId,
      pname: fullRegisterName,
    };

    dispatch({
      type: "WARNING_MODAL_SHOW",
      payLoad: true,
      data: qrManualTransactionParams,
    });

    // dispatch(
    //   postIdrCreateTransaction(qrManualTransactionParams, navigation, params.id)
    // );
  };

  // useEffect(() => {
  //   if (error) {
  //     navigate(`/idr/${params.id}`);
  //   }
  // }, [error]);

  return (
    <Slide className="d-flex justify-content-center align-items-center">
      <CnyWarningModal
        visible={modalShow}
        lang={props.lang}
        closeIcon={<span></span>}
        maskClosable={false}
        // centered={true}
        footer={null}
        bodyStyle={{ borderRadius: 10 }}
        width={370}
      />
      <CardWrapper>
        <div className="card-header w-100">
          <h3 className="text-center" style={{ color: "#fff" }}>
            付款信息
          </h3>
        </div>
        <div className="w-100 p-4">
          <div className=" d-flex align-items-center justify-content-between">
            <div className="w-75">
              <p className="label mb-0 mt-3">
                交易参考号: <strong>{data?.trxRef}</strong>
              </p>
              <p className="label mb-0 mt-3">
                金额（人民币）:{" "}
                <strong>{toLocaleStringFormate(data?.amount)}</strong>
              </p>
            </div>
            <img
              src={PapayaLogo}
              width={50}
              height={50}
              className="w-25 d-flex justify-content-center"
            />
          </div>
          <Divider />
          <p className="label mb-1 fw-bold">请填写您在身份证上注册的全名</p>
          <InputWrapper
            style={{ borderRadius: 10, marginTop: 0 }}
            name="fullName"
            type="text"
            size="large"
            value={fullRegisterName}
            onChange={(e) => setFullRegisterName(e.target.value)}
          />
          {fullRegisterName == "" || !isChinese(fullRegisterName) ? (
            <p style={{ color: "red" }}>{errorEmptyField}</p>
          ) : null}

          <p
            className="d-flex align-items-center"
            style={{ color: "orange", fontSize: 14, marginTop: 15 }}
          >
            <ExclamationCircleOutlined
              style={{ color: "orange", marginRight: 8, fontSize: 20 }}
            />{" "}
            请提供根据您的身份证件上的姓名以进行付款验证
          </p>
          <div className="w-100">
            <ButtonWrapper
              border={true}
              size="middle"
              height="40px"
              htmlType="submit"
              className="w-100 mt-4"
              text="继续付款"
              // loading={isLoading}
              onClick={() => {
                if (fullRegisterName == "") {
                  setErrorEmptyField("请填写您的注册全名");
                } else if (!isChinese(fullRegisterName)) {
                  setErrorEmptyField("請用中文輸入您的姓名");
                } else {
                  handleProceedFunc();
                }
              }}
            />
          </div>
        </div>
      </CardWrapper>
    </Slide>
  );
};

export default CnyMethodTransactionInfoCard;
